"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHexColor = void 0;
var hexRegex = /^#([A-F0-9]{6}|[A-F0-9]{3})$/i;
var isHexColor = function (str) { return hexRegex.test(str); };
exports.isHexColor = isHexColor;
